export function registerAdminSocialAgentEntry() {
  if (typeof window === "undefined") return;

  const ENTRY_ID = "clickgard-admin-social-agent-entry";

  const inject = () => {
    if (window.location.pathname !== "/admin") return;
    if (document.getElementById(ENTRY_ID)) return;

    const heading = Array.from(document.querySelectorAll<HTMLElement>("h1")).find((el) =>
      (el.textContent || "").toLowerCase().includes("administration"),
    );
    if (!heading) return;

    const container = heading.parentElement?.parentElement;
    if (!container) return;

    const card = document.createElement("a");
    card.id = ENTRY_ID;
    card.href = "/admin/social-agent";
    card.setAttribute("aria-label", "Ouvrir l'Agent Réseaux Click&Gard");
    card.className =
      "mb-6 flex items-center justify-between gap-4 rounded-2xl border border-primary/25 bg-primary/5 p-4 shadow-sm transition hover:bg-primary/10 hover:shadow-md";

    card.innerHTML = `
      <div class="flex min-w-0 items-center gap-3">
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary text-primary-foreground text-xl">✦</div>
        <div class="min-w-0">
          <div class="flex flex-wrap items-center gap-2">
            <strong class="text-base text-foreground">Agent Réseaux</strong>
            <span class="rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-semibold text-primary">NOUVEAU</span>
          </div>
          <p class="mt-0.5 text-sm text-muted-foreground">Créer, valider, programmer et préparer les publications Facebook, Instagram et TikTok.</p>
        </div>
      </div>
      <span class="shrink-0 text-sm font-semibold text-primary">Ouvrir →</span>
    `;

    const stats = container.querySelector(".grid");
    if (stats && stats.parentElement === container) {
      container.insertBefore(card, stats);
    } else {
      heading.parentElement?.insertAdjacentElement("afterend", card);
    }
  };

  const schedule = () => window.requestAnimationFrame(inject);

  schedule();

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("popstate", schedule);

  const originalPushState = history.pushState.bind(history);
  history.pushState = ((...args: Parameters<History["pushState"]>) => {
    originalPushState(...args);
    schedule();
  }) as History["pushState"];

  const originalReplaceState = history.replaceState.bind(history);
  history.replaceState = ((...args: Parameters<History["replaceState"]>) => {
    originalReplaceState(...args);
    schedule();
  }) as History["replaceState"];
}
